import React from "react";

import { Tooltip } from "@mui/material";
import ShipeeziNewGrid, { Column } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";
import { AiOutlinePicture } from "react-icons/ai";
import { FiCopy, FiEye } from "react-icons/fi";

import BadgeItemJobStatus from "../../../../../../../../../../components/Generic/BadgeItemJobStatus";
import { IDescriptiveSymbol } from "../../../../../../../../../../models/inventory";
import { ItemTypes } from "../../../../../../../../../../models/item.types";
import { Room } from "../../../../../../../../../../models/room";
import { handleGetConvertValue } from "../../../../../../../../../../util/converts";
import { getMeasurement } from "../../../../../../../../../../util/getMeasurement";

interface ListGridProps {
  data: Array<any>;
  selects: number[];
  setSelects: (values: number[]) => void;
}

export const ListGrid = ({ data, selects, setSelects }: ListGridProps) => {
  const { t: translate } = useTranslation();

  const columns: Column[] = [
    {
      name: "id",
      title: `${translate("item")} #`,
    },
    {
      name: "description",
      title: translate("description"),
    },
    {
      name: "storageSpace",
      title: translate("storageSpace"),
    },
    {
      name: "itemType",
      hideSearch: true,
      title: translate("packingType"),
      formatText: (itemType: ItemTypes) => itemType?.name,
    },
    {
      name: "volume",
      title: translate("volume"),
      formatText: (volume: number) =>
        `${handleGetConvertValue(
          volume,
          getMeasurement()?.code,
          getMeasurement()?.decimalPlaces
        )} ${getMeasurement()?.code}`,
    },
    {
      name: "packer",
      title: translate("packer"),
    },
    {
      name: "room",
      title: translate("room"),
      hideSearch: true,
      formatText: (room: Room) => room.name,
    },
    {
      name: "symbol",
      hideSearch: true,
      title: translate("descriptiveSymbol"),
      formatText: (symbol: IDescriptiveSymbol) => symbol.name,
    },
    {
      name: "condition",
      title: translate("condition"),
    },
    {
      name: "status",
      title: translate("status"),
      formatComponent: (status: string) => <BadgeItemJobStatus value={status} />,
    },
  ];

  return (
    <ShipeeziNewGrid
      data={data}
      columns={columns}
      totalItems={0}
      loadingData={false}
      pageSize={10}
      pageSizeList={[20, 40, 60, 100]}
      onChangePageSize={() => {}}
      onNextPage={() => {}}
      onPreviousPage={() => {}}
      onGoToPage={() => {}}
      rowActions={{
        orderBy: ["handleEdit", "view", "duplicate", "pictures"],
        handleEdit: () => {},
      }}
      rowActionsExtra={[
        {
          title: translate("view"),
          key: "view",
          buttonAndAction: (_id: number) => {
            return (
              <Tooltip title={translate("view")} placement="top">
                <div>
                  <FiEye size={18} />
                </div>
              </Tooltip>
            );
          },
        },
        {
          title: translate("duplicate"),
          key: "duplicate",
          buttonAndAction: (_id: number) => {
            return (
              <Tooltip title={translate("duplicate")} placement="top">
                <div>
                  <FiCopy size={18} />
                </div>
              </Tooltip>
            );
          },
        },
        {
          title: translate("picture"),
          key: "pictures",
          buttonAndAction: (_id: number) => {
            return (
              <Tooltip title={translate("pictures")} placement="top">
                <div>
                  <AiOutlinePicture size={18} />
                </div>
              </Tooltip>
            );
          },
        },
      ]}
      positionActionsColumn="right"
      selecteds={selects}
      handleSelect={setSelects}
    />
  );
};
